import React from 'react';
import { MdLockOutline } from "react-icons/md";
import { PiBriefcaseDuotone } from "react-icons/pi";
import { FaLaptopCode } from "react-icons/fa";
import { MdOutlineDesignServices } from "react-icons/md";


const Skillspanel = ({params}) => (
    <div className="card">
    <div className="card-header">
      <p className="ar">Hard Skills</p>
      <p className="en">مهارات الصلبة</p>
    </div>
    <div className="card-body">

      <h2 style={{color: '#40739e'}}><PiBriefcaseDuotone /></h2>
      <h4 style={{color: '#40739e'}}>1- Project Managment</h4>
        <em><b>Methodologies: </b>Agile, Scrum, Waterfall, Kanban.<br/>
            <b>Tools: </b> Jira, Microsoft Project</em>
      <hr></hr>
      <h2 style={{color: '#40739e'}}><MdLockOutline /></h2>
      <h4 style={{color: '#40739e'}}>2- Cybersecurity</h4>    
        <em><b>Concepts:</b>Security fundamentals, Access controls, Network security, Data security, Business contiunity and Disaster Recovery and Incident response.</em>  
      
      <hr></hr>
      <h2 style={{color: '#40739e'}}><FaLaptopCode /></h2>
      <h4 style={{color: '#40739e'}}>3- Programming</h4>
        <em><b>Languages: </b>Python, Java, JavaScript, C++, HTML, CSS, SQL.</em>
      
      <hr></hr>
      <h2 style={{color: '#40739e'}}><MdOutlineDesignServices /></h2>
      <h4 style={{color: '#40739e'}}>4- Design and Creative</h4>
        <em><b>Graphic Design:</b> Adobe Photoshop, Canva</em>


     {/*  <p>Front End: HTML, CSS</p>
        <div className="process" style={{background: '#2e2e2e', color: 'white', width: '100%'}}>100%</div>
      <p>Javascript (React Native/ React js)</p>
        <div className="process" style={{background: '#2e2e2e', color: 'white', width: '90%',}}>90%</div>
      <p>Javascript (Node jsExpressJS)</p>
        <div className="process" style={{background: '#2e2e2e', color: 'white', width: '85%',}}>80%</div>
      <p>SQL (mysql phpmyadmin, sqllite)</p>
        <div className="process" style={{background: '#2e2e2e', color: 'white', width: '85%',}}>85%</div>
      <p>NoSQL (MongoDB)</p>
      <div className="process" style={{background: '#2e2e2e', color: 'white', width: '85%',}}>85%</div>
      <p>Python</p>
      <div className="process" style={{background: '#2e2e2e', color: 'white', width: '90%',}}>90%</div>
      <p>Java</p>
        <div className="process" style={{background: '#2e2e2e', color: 'white', width: '90%',}}>90%</div>
      <p>PHP</p>
        <div className="process" style={{background: '#2e2e2e', color: 'white', width: '70%',}}>70%</div>
      <p>Photoshop designer</p>
        <div className="process" style={{background: '#2e2e2e', color: 'white', width: '70%',}}>70%</div> */}
    </div>
  </div>

);

export default Skillspanel;
